const { render, useState, useEffect } = wp.element;

const Contact = ({ pieceID }) => {
    const [piece, setPiece] = useState()

    useEffect(() => {
        if (pieceID) {
            fetch(rest.pieces + "/" + pieceID)
                .then(response => response.json())
                .then(data => { setPiece(data); console.log({ data }) })
        }
    }, [pieceID])

    return (
        <div className="contact-form__wrapper">
            {piece && <div className="contact-form--piece">
                <div className="image-wrapper"><img src={piece.thumb[0]} /></div>
                {piece.title && <h5 className="piece__title">{piece.title.rendered}</h5>}
                {piece.price && <h6 className="piece__price">${piece.price}</h6>}
            </div>}
            <form className="contact-form" action="/wp-json/cundiff/v1/contact/submit" method="POST">
                <input type="hidden" name="contact_piece_id" value={pieceID} />
                <input type="text" placeholder="Your Name" name="contact_name" />
                <input type="email" placeholder="Your Email" name="contact_email" />
                <input type="phone" placeholder="Phone Number" name="contact_phone_number" />
                <div className="grid grid--2">
                    <input type="text" placeholder="State" name="contact_state" />
                    <input type="text" placeholder="Shipping Zip" name="contact_zip" />
                </div>
                <textarea placeholder="Your Message" required  name="contact_message" id="message"></textarea>
                <button className="button button--full" type="submit">Submit Purchase Inquiry</button>
            </form>

        </div>
    );
};


export default function () {
    var form = document.getElementById(`contact_form`)
    if (form) {
        render(<Contact pieceID={form.dataset.piece} />, form);
    }
}